import { Navigate } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";

/**
 * Role-aware redirect wrapper around the main editor (`/`). If the
 * authenticated user has role=`asist_edit`, we send them to `/asist-edit`
 * — the simplified workflow they're allowed to use. Everyone else
 * (admin, regular user) sees the full SeedanceVFXTool.
 *
 * Placed inside the route tree (not the AuthContext) so it doesn't
 * trigger an extra render before children mount. Cheap: only checks
 * `user.role` once per render.
 */
export default function AsistEditGate({ children }) {
  const { user } = useAuth();
  if (user && (user.role || "user") === "asist_edit") {
    return <Navigate to="/asist-edit" replace />;
  }
  return children;
}
